import { render, staticRenderFns } from "./StockMateriaPrimeraEnMagatzemList.vue?vue&type=template&id=40ac0e39&scoped=true"
import script from "./StockMateriaPrimeraEnMagatzemList.vue?vue&type=script&lang=js"
export * from "./StockMateriaPrimeraEnMagatzemList.vue?vue&type=script&lang=js"
import style0 from "./StockMateriaPrimeraEnMagatzemList.vue?vue&type=style&index=0&id=40ac0e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac0e39",
  null
  
)

export default component.exports